export const GET_REFERRAL_CODE= 'GET_REFERRAL_CODE'
export const loadReferralCode=()=>({
    type:GET_REFERRAL_CODE,
})
export const SET_REFERRAL_CODE= 'SET_REFERRAL_CODE'
export const setReferralCode=(_referralCode:string)=>({
    type:SET_REFERRAL_CODE,
    payload: _referralCode
})